// Copyright ©️ 2026 eVolve MEP, LLC

import { useCallback } from 'react';

import { doSignOut, useEvolvePost } from '@evolvemep/api-ts';

export const useSignOut = () => {
  const { apiCall } = useEvolvePost('admin/authentication/logout');

  return useCallback(
    async (routeToLocation?: string) => {
      await apiCall({})
        /* oxlint-disable no-console */
        .catch(console.error)
        .finally(() => doSignOut(routeToLocation));
    },
    [apiCall],
  );
};
